import { EditorInput } from '../EditorInput';
import { customizeCraftJsComponent } from '../../helpers';

export const EditorEntityIdInput = customizeCraftJsComponent(EditorInput, {
	name: 'Entity ID Input',
	props: {
		name: 'entityId',
		type: 'text',
		placeholder: 'Entity ID',
		label: 'Entity ID'
	}
});
